import { isObject } from '@/utils/checks'
import { Location, LOCATION_TYPE_TITLE } from '../types/models/Location.model'
import { QuickLink } from '@prisma/client'
import { DISALLOWED_LOCATION_TYPES } from './location/constants'

export const getSlug = (location: Location): string => {
  return location?.slug || ''
}

export const getTitle = (location: Location): string => {
  return location?.title || ''
}

export const getIsLuxury = (location: Location): boolean => {
  return !!location?.isLuxury
}

export const getLocationParts = (location: Location): Partial<Location>[] => {
  if (isObject(location)) {
    return [
      ...(location.address_parts || location.location_address_parts || [])
    ].reverse()
  }

  return []
}

export const getLocationPartsTitles = (location: Location): string[] => {
  if (isObject(location)) {
    return getLocationParts(location).map(getTitle)
  }

  return []
}

export const getParentLocation = (location: Location): Partial<Location> => {
  const locationParts = getLocationParts(location)
  return locationParts[locationParts.length - 1] || {}
}

export const getAllLocationTitles = (location: Location): string[] => {
  if (isObject(location)) {
    const locationParts = getLocationParts(location)
    return [getTitle(location)].concat(locationParts.map(getTitle))
  }
  return []
}

export function getLocationQuickLinks(location?: Location): QuickLink[] {
  return location?.quick_links || []
}

const LOCATION_TYPE_ORDER = {
  Continent: 1,
  Country: 2,
  Region: 3,
  City: 4
}

export const orderLocationsByType = (
  locations: Partial<Location>[]
): Partial<Location>[] => {
  return locations.sort((a, b) => {
    return (
      (LOCATION_TYPE_ORDER[a.type as string] || 99) -
      (LOCATION_TYPE_ORDER[b.type as string] || 99)
    )
  })
}
